import type {
  ColumnDef,
  Leaves,
  LedgerUpdateTypeEnum,
  Position,
  PositionUpdateSourceEnum,
  ProductTypeEnum,
  SubAccountTypeEnum,
  TabProps,
} from '@talos/kyoko';
import type { UnifiedPosition } from './Unified/UnifiedPosition';

export interface BasePositionsTabProps extends TabProps {
  tag?: string;
  defaultFilter?: PositionsTableFilter;
  defaultColumns: PositionColumn[];
  showZeroBalances: boolean;
}

export interface SpotPositionsTabProps extends BasePositionsTabProps {
  tabType: 'Spot';
}

export interface DerivativesPositionsTabProps extends BasePositionsTabProps {
  tabType: 'Derivatives';
}

export interface UnifiedPositionsTabProps extends TabProps {
  defaultColumns: UnifiedPositionColumn[];
  tabType: 'Unified';
  includeCash?: boolean;
  tag?: string;
  defaultFilter?: PositionsTableFilter;
  showZeroBalances: boolean;
}

export interface SubAccountPositionsTabProps extends BasePositionsTabProps {
  tabType: 'Sub Accounts';
  includeCash?: boolean;
  hierarchical?: boolean;
}

export type PositionsTabProps =
  | SubAccountPositionsTabProps
  | SpotPositionsTabProps
  | DerivativesPositionsTabProps
  | UnifiedPositionsTabProps;

export type PositionsTabType = 'Derivatives' | 'Spot' | 'Sub Accounts' | 'Unified';

// The UnifiedPosition stuff here is adding a lot of complexity. The backend will do all this for us instead asap and we can remove all this shit.
export type ExtraUnifiedPositionColumns = keyof Pick<UnifiedPosition, 'market' | 'marketAccountGroup' | 'underlying'>;
export type ExtraPositionColumns = 'expiry' | 'instrument' | 'SubAccountType' | 'underlying';

export type UnifiedPositionColumn =
  | Leaves<UnifiedPosition>
  | ExtraPositionColumns
  | ExtraUnifiedPositionColumns
  | Partial<ColumnDef<UnifiedPosition>>;
export type PositionColumn = Leaves<Position> | ExtraPositionColumns | Partial<ColumnDef<Position>>;

export interface PositionsTableFilter {
  Source?: PositionUpdateSourceEnum;
  AssetTypes?: ProductTypeEnum[];
  SubAccounts?: string[];
  Symbols?: string[];
  SubAccountTypes?: SubAccountTypeEnum[];
  Expiries?: string[];
  MarketAccounts?: string[];
  Markets?: string[];
  MarketAccountGroups?: string[];
  MarketAccountTypes?: string[];
}

export function colIDToFilterBuilderKey(id: string): keyof PositionsTableFilter | undefined {
  switch (id as keyof Position | ExtraPositionColumns | ExtraUnifiedPositionColumns) {
    case 'SubAccountType':
      return 'SubAccountTypes';
    case 'AssetType':
      return 'AssetTypes';
    case 'Asset':
      return 'Symbols';
    case 'instrument':
      return 'Symbols';
    case 'PositionSource':
      return 'Source';
    case 'SubAccount':
      return 'SubAccounts';
    case 'expiry':
      return 'Expiries';
    case 'MarketAccount':
      return 'MarketAccounts';
    case 'market':
      return 'Markets';
    case 'marketAccountGroup':
      return 'MarketAccountGroups';
  }
  return undefined;
}

export type ClonePositionsTabFunc = () => void;

export enum SubAccountPositionsBlotterMode {
  Standard = 'Standard',
  Advanced = 'Advanced',
}

export interface UpdatePositionForm {
  updateType?: LedgerUpdateTypeEnum;
  subAccount?: string;
  marketAccount?: string;
  asset?: string;
  amount?: string;
  avgCost?: string;
  avgCostCurrency?: string;
  timestamp?: Date;
  comments?: string;
}
